import { put, take } from 'redux-saga/effects';

import { showPromptModal } from '../../actions/actionCreatorsCommon'
import * as ActionTypes from '../../constants/constant_action_types';

export function* promptModal(header, body, confirmOnly) {
  let signal = false;
  yield put(showPromptModal(header, body, confirmOnly));
  yield take((a) => {
    if (a.type !== ActionTypes.COMMON_PROMPT_MODAL_SIGNAL) return false;
    signal = a.signal;
    return true;
  });
  yield take(ActionTypes.COMMON_PROMPT_MODAL_HIDE);
  return signal;
}
